// extracted by mini-css-extract-plugin
module.exports = {"container":"Artist_container__CDeOb","mat":"Artist_mat__ZmXGZ","caption":"Artist_caption__3c4Mk","title":"Artist_title__1evVH","info":"Artist_info__2aKkb"};